import { render } from "./HeaderBarsButton.vue?vue&type=template&id=1dc2d6e8&scoped=true"
import script from "./HeaderBarsButton.vue?vue&type=script&lang=js"
export * from "./HeaderBarsButton.vue?vue&type=script&lang=js"

import "./HeaderBarsButton.vue?vue&type=style&index=0&id=1dc2d6e8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc2d6e8"]])

export default __exports__